import { Link } from 'react-router-dom';
import type { Video } from '@/mocks/videos';

interface VideoCardProps {
  video: Video;
}

export default function VideoCard({ video }: VideoCardProps) {
  return (
    <Link
      to={`/article/${video.id}`}
      className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
    >
      <div className="relative overflow-hidden aspect-video">
        <img
          src={video.thumbnail}
          alt={video.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          title={`${video.title} - 星空传媒高清资源`}
        />
        <div className="absolute top-3 left-3">
          <span className="px-2 py-0.5 text-xs font-medium rounded-md bg-background-950/70 text-background-50 backdrop-blur-sm whitespace-nowrap">
            {video.duration}
          </span>
        </div>
        {video.isNew && (
          <div className="absolute top-3 right-3">
            <span className="px-2 py-0.5 text-xs font-semibold rounded-md bg-accent-500 text-background-50 whitespace-nowrap">
              NEW
            </span>
          </div>
        )}
        {video.isHot && !video.isNew && (
          <div className="absolute top-3 right-3">
            <span className="px-2 py-0.5 text-xs font-semibold rounded-md bg-primary-500 text-background-50 whitespace-nowrap">
              热播
            </span>
          </div>
        )}
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <span className="inline-block px-3 py-1 text-xs font-medium rounded-full bg-accent-500 text-background-50 whitespace-nowrap">
            立即观看
          </span>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-950 line-clamp-1 group-hover:text-primary-600 transition-colors">
          {video.title}
        </h3>
        <div className="flex items-center gap-3 mt-1.5">
          <div className="flex items-center gap-1">
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-star-fill text-accent-500 text-xs"></i>
            </div>
            <span className="text-xs text-foreground-600">{video.rating}</span>
          </div>
          <span className="text-xs text-foreground-400">{video.views}次播放</span>
        </div>
        <div className="flex items-center gap-1.5 mt-2 flex-wrap">
          {video.tags.slice(0, 2).map((tag) => (
            <span
              key={tag}
              className="px-2 py-0.5 text-xs rounded-md bg-background-100 text-foreground-500 whitespace-nowrap"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}